'use es6';

export var BOOKING_TIME_CONFLICT = 'meeting booked from underneath';
export var INVALID_DOMAIN_FOR_LINK = 'INVALID_DOMAIN_FOR_LINK';
export var NOT_FOUND = 'Link not found';
export var USER_NOT_FOUND = 'User not found';
export var MEETING_PREVIOUSLY_CANCELLED = 'Could not complete reschedule request, meeting was previously cancelled.';
export var REBOOK_CONFLICT = 'Could not complete reschedule request, event times conflict with existing event.';